<template>
  <v-dialog persistent max-width="600px" v-model="dialog">
    <v-card>
      <v-card-title class="py-0 pl-0 pr-2">
        <v-chip class="ma-2" color="warning" outlined pill>
          <v-icon left> mdi-alert-circle </v-icon>
          {{ title }}
        </v-chip>
        <v-spacer></v-spacer>
        <v-btn icon color="red" @click="cancel">
          <v-icon>mdi-close-octagon-outline</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-textarea
                outlined
                label="Alasan Ditolak"
                hide-details="auto"
                v-model="form.alasan_ditolak"
                :error-messages="errors.alasan_ditolak"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="confirmTolak" color="red" dark>Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      resolve: null,
      reject: null,
      dialog: false,
      title: null,
      route: null,
      id: null,
      form: {
        alasan_ditolak: null,
      },
      formDefault: {
        alasan_ditolak: null,
      },
      errors: [],
      special: false,
    };
  },

  methods: {
    open(id, title, route, special) {
      this.dialog = true;
      this.title = title;
      this.route = route;
      this.id = id;
      this.form = Object.assign({}, this.formDefault);
      if (special) this.special = special;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    confirmTolak() {
      this.$store.commit("SET_OVERLAY", true);
      if (this.special) {
        this.reset();
        this.resolve(this.form);
        return;
      }
      axios
        .put("/api/tolak-" + this.route + "/" + this.id, this.form)
        .then(() => {
          this.reset();
          this.resolve(true);
        })
        .catch((e) => {
          this.errors = e.response.data.errors;
          this.reject(false);
        })
        .finally(() => {
          this.$store.commit("SET_OVERLAY", false);
        });
    },

    cancel() {
      this.reset();
      this.resolve(false);
    },

    reset() {
      this.dialog = false;
      setTimeout(() => {
        this.title = null;
        this.route = null;
        this.errors = [];
        this.special = false;
      }, 250);
    },
  },
};
</script>

<style>
</style>